import { get } from 'lodash';
import env from 'utilities/env';
import { urlMap as ROUTE_CONSTANTS } from 'routes/urlMap';
import { urlDeconstructor } from 'utilities/route';
import { PORTAL_TASKS } from '../constants';

// essentially beamEnv('PUBLIC_URL') || get(process.env, 'PUBLIC_URL');
// use injected public url or build time public url
// if neither is set, default to '/'
const PUBLIC_URL = env('PUBLIC_URL') || '/';

const routePortalTaskMap = {
  [ROUTE_CONSTANTS.HOME]: PORTAL_TASKS.HOME,
  [ROUTE_CONSTANTS.NEW_JOB]: PORTAL_TASKS.NEW_JOB_REQUEST,
  [ROUTE_CONSTANTS.NEW_JOB_FROM_COPY]: PORTAL_TASKS.NEW_JOB_REQUEST_FROM_COPY,
  [ROUTE_CONSTANTS.NEW_JOB_FROM_REPOST]: PORTAL_TASKS.NEW_JOB_REQUEST_FROM_REPOST,
  [ROUTE_CONSTANTS.NEW_JOB_FROM_SCRATCH]: PORTAL_TASKS.NEW_JOB_REQUEST_FROM_SCRATCH,
  [ROUTE_CONSTANTS.NEW_JOB_FROM_TEMPLATE]: PORTAL_TASKS.NEW_JOB_REQUEST_FROM_TEMPLATE,
  [ROUTE_CONSTANTS.NEW_JOB_TEMPLATES]: PORTAL_TASKS.NEW_JOB_REQUEST_TEMPLATES,
  [ROUTE_CONSTANTS.EDIT_JOB]: PORTAL_TASKS.EDIT_JOB_REQUEST,
  [ROUTE_CONSTANTS.EDIT_JOB_SECTION]: PORTAL_TASKS.EDIT_JOB_REQUEST_SECTION,
  [ROUTE_CONSTANTS.NEW_TEMPLATE]: PORTAL_TASKS.NEW_TEMPLATE,
  [ROUTE_CONSTANTS.EDIT_TEMPLATE]: PORTAL_TASKS.EDIT_TEMPLATE,
  [ROUTE_CONSTANTS.MAGIC]: PORTAL_TASKS.JOB_REQUEST_POSTED,
  [ROUTE_CONSTANTS.REPORT_ATTENDANCE]: PORTAL_TASKS.JOBS_REPORT,
  [ROUTE_CONSTANTS.MANAGE_JOBS]: PORTAL_TASKS.MANAGE_JOBS,
  [ROUTE_CONSTANTS.SUMMARY_REPORT]: PORTAL_TASKS.SUMMARY_REPORT,
  [ROUTE_CONSTANTS.WONOLOERS]: PORTAL_TASKS.WONOLOERS,
  [ROUTE_CONSTANTS.WORKERS]: PORTAL_TASKS.WORKERS,
  [ROUTE_CONSTANTS.JOB_REQUESTS_IMPORT]: PORTAL_TASKS.JOB_REQUESTS_IMPORT,
  [ROUTE_CONSTANTS.JOB_REQUEST_IMPORTED_FILE]: PORTAL_TASKS.JOB_REQUEST_IMPORTED_FILE,
  [ROUTE_CONSTANTS.JOB_REQUESTS]: PORTAL_TASKS.JOB_REQUEST_DETAILS,
  [ROUTE_CONSTANTS.NOTIFICATION_PREFERENCES]: PORTAL_TASKS.NOTIFICATION_PREFERENCES,
  [ROUTE_CONSTANTS.WANDAS]: PORTAL_TASKS.WANDAS,
  [ROUTE_CONSTANTS.DASHBOARD]: PORTAL_TASKS.DASHBOARD,
  [ROUTE_CONSTANTS.COMPANY_PAGE]: PORTAL_TASKS.MY_COMPANY,
  [ROUTE_CONSTANTS.EDIT_REQUESTOR_INFO]: PORTAL_TASKS.MY_COMPANY,
  [ROUTE_CONSTANTS.ADD_REQUESTOR]: PORTAL_TASKS.MY_COMPANY,
};

// needed to sanitize public routes like "/frontend" without affecting routes like "/"
const ensureSlashes = (path) => {
  const startsWithSlash = path.startsWith('/');
  const endsInSlash = path.endsWith('/');
  return `${startsWithSlash ? '' : '/'}${path}${endsInSlash ? '' : '/'}`;
};

// Removes public path from pathname so that urlDeconstructor can match properly
const sanitizePathname = (pathname) => {
  const prefix = ensureSlashes(PUBLIC_URL);
  const sanitizedPathName = pathname.replace(prefix, '/');
  return sanitizedPathName;
};

export const getPortalTaskFromRoute = (pathname) => {
  const sanitizedPathName = sanitizePathname(pathname);
  const deconstructedUrl = urlDeconstructor(ROUTE_CONSTANTS, sanitizedPathName);
  return get(routePortalTaskMap, deconstructedUrl.pattern, PORTAL_TASKS.NO_TASK);
};

export default getPortalTaskFromRoute;
